import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { ReviewList } from '../components/sections/review-list';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

interface ReviewsPageProps {
  content: SiteContent;
}

export function ReviewsPage({ content }: ReviewsPageProps): JSX.Element {
  return (
    <>
      <PageHero title={content.reviewsSection.headline} text={content.reviewsSection.subheadline} />
      <section className="pb-12 sm:pb-16">
        <Container className="space-y-6">
          <Card className="bg-white">
            <CardContent className="grid gap-4 p-6 md:grid-cols-[1fr_auto] md:items-center">
              <div className="space-y-1">
                <p className="text-2xl font-semibold text-[color:var(--color-text)]">{content.reviewsSection.summary.ratingLabel}</p>
                <p className="text-sm text-[color:var(--color-muted)]">{content.reviewsSection.summary.reviewCountLabel}</p>
                <p className="text-sm text-[color:var(--color-muted)]">{content.reviewsSection.summary.sourceLabel}</p>
              </div>
              <div className="flex flex-wrap gap-2">
                <Button asChild>
                  <a href={content.reviewsSection.reviewCtas.primary.href}>{content.reviewsSection.reviewCtas.primary.label}</a>
                </Button>
                <Button asChild variant="outline">
                  <a href={content.reviewsSection.reviewCtas.secondary.href}>{content.reviewsSection.reviewCtas.secondary.label}</a>
                </Button>
              </div>
            </CardContent>
          </Card>

          <ReviewList content={content} />
        </Container>
      </section>
    </>
  );
}
